import { render, staticRenderFns } from "./DepositUseVega.vue?vue&type=template&id=0ce8abbb"
import script from "./DepositUseVega.vue?vue&type=script&lang=js"
export * from "./DepositUseVega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports